import React, { Component } from 'react'

// import classes from './ReportAppraisal.scss'
import { extractFilterOptions, updateFilterOptions, updateObject } from '../../../../helpers/utils'
// import { withTranslate } from 'react-redux-multilingual'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
import ReportPreview from '../../../../components/ReportPreview/ReportPreview'
import Grid from '@material-ui/core/Grid'
import PageInfo from '../../../../components/PageInfo/PageInfo'
import { withTranslate } from 'react-redux-multilingual'
class ReportPerformanceForm extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    filterControls: {
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        value: '',
        configs: {
          placeholder: this.props.translate('appraisalType'),
          options: []
        },
        required: true
      },
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('levelGroup'),
          options: []
        }
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        }
      },
      position_id: {
        label: this.props.translate('position'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('position') }
          ]
        }
      },
      emp_id: {
        label: this.props.translate('employee'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('employee'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('employee') }
          ]
        }
      },
      format: {
        label: this.props.translate('format'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('format'),
          options: [
            { key: 1, value: 'pdf', label: 'PDF' },
            { key: 2, value: 'xlsx', label: 'Excel' }
          ]
        },
        required: true
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      filterCompany: this.props.filterCompany,
      filterForm: this.props.filterForm,
      filterLevelGroup: this.props.filterLevelGroup,
      filterOrg: this.props.filterOrg,
      filterPosition: this.props.filterPosition,
      filterEmp: this.props.filterEmp,
      filterAppraisalType: this.props.filterAppraisalType
    },
    filterOptions: {
      appraisalTypeOptions: null,
      companyFilterOptions: null,
      formFilterOptions: null,
      levelGroupFilterOptions: null,
      orgFilterOptions: null,
      positionFilterOptions: null,
      empFilterOptions: null
    },
    // Cache
    filteredCache: null
  }

  // componentDidUpdate(prevprops) {
  //   if (prevprops.success !== this.props.success && this.props.success) {
  //     this.clearModal()
  //   }
  // }
  componentDidMount = () => {
    this.props.fetchAppraisalTypeOptions()
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = { ...state }

    if (props.filtered !== updatedState.filteredCache) {
      updatedState = { ...updatedState, filteredCache: props.filtered }
    }
    if (
      props.filterOptions.appraisalTypeOptions !== updatedState.filterOptions.appraisalTypeOptions
    ) {
      const appraisalTypeFilter = updatedState.filterControls.appraisal_type_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.appraisalTypeOptions,
        appraisalTypeFilter,
        'appraisal_type_id',
        'appraisal_type_id',
        { name: 'appraisal_type_name', code: 'appraisal_type_code' },
        'Select Appraisal Type',
        false,
        updatedState.filterControls.appraisal_type_id.value,
        'appraisal_type_code'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.appraisal_type_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          appraisal_type_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          appraisalTypeOptions: props.filterOptions.appraisalTypeOptions
        }
      }
    }
    if (
      props.filterOptions.companyFilterOptions !== updatedState.filterOptions.companyFilterOptions
    ) {
      const companyFilter = updatedState.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select company'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.company_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          company_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }
    if (props.filterOptions.formFilterOptions !== updatedState.filterOptions.formFilterOptions) {
      const formFilter = updatedState.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.form_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { form_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }
    if (
      props.filterOptions.levelGroupFilterOptions !==
      updatedState.filterOptions.levelGroupFilterOptions
    ) {
      const levelGroupFilter = updatedState.filterControls.level_group_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select level'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.level_group_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          level_group_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          levelGroupFilterOptions: props.filterOptions.levelGroupFilterOptions
        }
      }
    }
    if (props.filterOptions.orgFilterOptions !== updatedState.filterOptions.orgFilterOptions) {
      const orgFilter = updatedState.filterControls.org_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )
      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(item => item.value === props.filtered?.org_id) ||
          null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { org_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          orgFilterOptions: props.filterOptions.orgFilterOptions
        }
      }
    }
    if (
      props.filterOptions.positionFilterOptions !== updatedState.filterOptions.positionFilterOptions
    ) {
      const positionFilter = updatedState.filterControls.position_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.positionFilterOptions,
        positionFilter,
        'position_id',
        'position_id',
        { name: 'position_name', code: 'position_code' },
        'Select position'
      )

      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.position_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          position_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          positionFilterOptions: props.filterOptions.positionFilterOptions
        }
      }
    }
    if (props.filterOptions.empFilterOptions !== updatedState.filterOptions.empFilterOptions) {
      const employeeFilter = updatedState.filterControls.emp_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.empFilterOptions,
        employeeFilter,
        'emp_id',
        'emp_id',
        { name: 'full_name', code: 'emp_code' },
        'Select employee'
      )

      let value = null
      if (props.filtered !== updatedState.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(item => item.value === props.filtered?.emp_id) ||
          null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { emp_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          empFilterOptions: props.filterOptions.empFilterOptions
        }
      }
    }
    return updatedState
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })
    this.props.fetchFilter()
    this.props.clearReportPerformanceform()
    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }

  handleFilterChange = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    let updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })

    const filterOptions = {
      appraisal_type_id: updatedFilterControls.appraisal_type_id.value?.value,
      company_id: updatedFilterControls.company_id.value?.value,
      level_group_id: updatedFilterControls.level_group_id.value?.value,
      org_id: updatedFilterControls.org_id.value?.value,
      position_id: updatedFilterControls.position_id.value?.value
    }

    if (itemKey === 'appraisal_type_id') {
      // const emp = filterControls.emp_id
      // const pos = filterControls.position_id
      // const org = filterControls.org_id
      // const updatedEmp = { ...emp, configs: { ...emp.configs, disabled: event?.code === 'APT01' } }
      // const updatedPos = { ...pos, configs: { ...pos.configs, disabled: event?.code === 'APT01' } }
      // const updatedOrg = { ...org, required: event?.code === 'APT01' }

      // updatedFilterControls = {
      //   ...updatedFilterControls,
      //   emp_id: updatedEmp,
      //   position_id: updatedPos,
      //   org_id: updatedOrg
      // }

      const { label } = event
      const { filterControls } = this.state
      if (label.includes('Individual')) {
        filterControls.company_id.required = true
        filterControls.form_id.required = true
        filterControls.org_id.required = false
        filterControls.position_id.required = false
        filterControls.emp_id.required = false

        filterControls.position_id.configs.disabled = false
        filterControls.emp_id.configs.disabled = false
      } else {
        filterControls.company_id.required = true
        filterControls.form_id.required = true
        filterControls.org_id.required = false
        filterControls.position_id.required = false
        filterControls.emp_id.required = false

        filterControls.position_id.configs.disabled = true
        filterControls.emp_id.configs.disabled = true
      }

      updatedFilterControls = {
        ...updatedFilterControls
      }
    }
    if (['appraisal_type_id'].includes(itemKey) && filterOptions.appraisal_type_id) {
      this.props.fetchCompanyOptions(filterOptions)
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrganizationOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (['company_id'].includes(itemKey) && filterOptions.appraisal_type_id) {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrganizationOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchOrganizationOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'org_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'position_id') {
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'emp_id') {
      // if (updatedFilterControls.org_id.value === null) {
      //   let findEmp = this.props.filterOptions.empFilterOptions.find(
      //     item => item.emp_id === event.value
      //   )
      //   let org_id = findEmp.empdetails[0].org_id
      //   updatedFilterControls.org_id.value = updatedFilterControls.org_id.configs.options.find(
      //     item => item.value === org_id
      //   )
      // }
      // if (updatedFilterControls.position_id.value === null) {
      //   let findEmp = this.props.filterOptions.empFilterOptions.find(
      //     item => item.emp_id === event.value
      //   )
      //   let position_id = findEmp.empdetails[0].position_id
      //   updatedFilterControls.position_id.value = updatedFilterControls.position_id.configs.options.find(
      //     item => item.value === +position_id
      //   )
      // }
    }

    console.log('update', updatedFilterControls)

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let filters = extractFilterOptions(this.state.filterControls)
    const appraisalType = this.state.filterControls.appraisal_type_id.value
    const company = this.state.filterControls.company_id.value

    this.setState({
      appraisalType: appraisalType,
      company: company
    })

    // this.props.fetchDashboardOverallPerformace({ ...filters, appraisalType, company })
    // this.closeFilterModal(true)

    let par = {
      param_appraisal_type: filters?.appraisal_type_id,
      param_company: filters?.company_id,
      param_form: filters?.form_id,
      param_level_group: filters?.level_group_id,
      param_org: filters?.org_id,
      param_position: filters?.position_id,
      param_emp: filters?.emp_id
    }
    let parameters = {}
    Object.entries(par).map(form => {
      let [key, formAttrs] = form

      if (formAttrs !== undefined) {
        parameters = {
          ...parameters,
          [key]: formAttrs
        }
      }
      return form
    })

    let param = {
      parameters: parameters,
      appraisal_type_id: filters.appraisal_type_id,
      format: filters.format,
      locale: localStorage.getItem('language')
    }
    this.props.reportPerformanceform(param)
    this.setState({
      openPreview: true
    })
    this.closeFilterModal()
  }

  render() {
    let formLoading = <Spinner />
    if (!this.props.loading) {
      formLoading = <PleaseFilter />
    }
    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.filterLoading}
        />
        <Alert />
        <Card>
          <CardHeader
            title={
              <Grid container>
                <Grid item xs sm md>
                  <PageInfo pageTranslateKey={'reportPerformanceForm'} />
                </Grid>
                <Grid item xs sm md={4}>
                  <FilterBar buttonClicked={this.openFilterModal} />
                </Grid>
              </Grid>
            }></CardHeader>
          <CardBody>
            {formLoading}
            {this.props.report !== null ? (
              <ReportPreview
                format={this.state.filter.format}
                file={this.props.report}></ReportPreview>
            ) : null}
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    loading: state.reportPerformanceform.loading,
    filterLoading: state.reportPerformanceform.loadingStates,
    success: state.reportPerformanceform.success,
    report: state.reportPerformanceform.report,
    filterOptions: {
      appraisalTypeOptions: state.reportPerformanceform.appraisalType,
      companyFilterOptions: state.reportPerformanceform.company,
      formFilterOptions: state.reportPerformanceform.form,
      levelGroupFilterOptions: state.reportPerformanceform.levelGroup,
      orgFilterOptions: state.reportPerformanceform.org,
      positionFilterOptions: state.reportPerformanceform.position,
      empFilterOptions: state.reportPerformanceform.emp
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchFilter: filter => {
      // dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchAppraisalTypeOptionsForAppraisal())
      // dispatch(actions.fetchFormOptionsForAppraisal())
      // dispatch(actions.fetchLevelGroupOptionsForAppraisal())
      // dispatch(actions.fetchOrganizationOptionsForAppraisal())
      // dispatch(actions.fetchPositionOptionsForAppraisal())
      // dispatch(actions.fetchEmployeeOptionsForAppraisal())
    },
    fetchAppraisalTypeOptions: filter => dispatch(actions.fetchAppraisalTypeOptionsForAppraisal()),
    fetchCompanyOptions: filter => dispatch(actions.fetchCompanyOptionsForAppraisal(filter)),
    fetchFormOptions: filter => dispatch(actions.fetchFormOptionsForAppraisal(filter)),
    fetchOrganizationOptions: filter =>
      dispatch(actions.fetchOrganizationOptionsForAppraisal(filter)),
    fetchPositionOptions: filter => dispatch(actions.fetchPositionOptionsForAppraisal(filter)),
    fetchEmployeeOptions: filter => dispatch(actions.fetchEmployeeOptionsForAppraisal(filter)),
    fetchLevelGroupOptions: filter => dispatch(actions.fetchLevelGroupOptionsForAppraisal(filter)),
    reportPerformanceform: filter => dispatch(actions.reportPerformanceform(filter)),
    clearReportPerformanceform: () => dispatch(actions.clearReportPerformanceform())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ReportPerformanceForm))
